<script lang="ts">
  //   import Grid from "../../../assets/icons/grid.svg.svelte";
  //   import MapPin from "../../../assets/icons/map-pin.svg.svelte";
  //   import PersonBadge from "../../../assets/icons/person-badge.svg.svelte";
  //   import Receipt from "../../../assets/icons/receipt.svg.svelte";
  //   import User from "../../../assets/icons/user.svg.svelte";
  //   import Users from "../../../assets/icons/users.svg.svelte";
  import { _ } from 'svelte-i18n';
  import { Link, navigate, useLocation } from 'svelte-navigator';
  // import Repeat from "../../../assets/icons/repeat.svg.svelte";
  import Logo from '../../assets/icons/logo.svg.svelte';
  import Chat from '../../assets/icons/chat.svg.svelte';
  //   import SmallLogo from "../../../assets/images/jcs-logo.png";
  import { debugLog } from '../../lib/debug-log';

  const location = useLocation();

  location.subscribe((loc) => {
    debugLog(loc);
    if (loc.pathname == '/admin') {
      navigate('/admin/new');
    }
  });

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('auth'); // Remove old auth flag too
    window.location.href = '/'; // Redirect to home page
  };
</script>

<div
  class="nav-container flex h-screen min-h-screen max-w-xs flex-grow flex-col overflow-auto border-r border-gray-200 bg-white sm:pt-5 sm:pb-4"
>
  <div class="flex flex-shrink-0 items-center space-y-5 px-4">
    <Link to="/admin" title="Admin">
      <div class="grid gap-4">
        <div class="flex justify-center">
          <Logo />
        </div>
        <div>
          <h1 class="font-CorpoS-Bold text-2xl">
            {$_('MBD Purchase Payback Registration')}
          </h1>
        </div>
      </div>

      <!-- <img class="h-6 sm:h-10 w-auto  lg:hidden" src={SmallLogo} alt="JCS" /> -->
    </Link>
  </div>
  <div class=" flex flex-grow flex-col sm:mt-5">
    <nav
      class="nav-items flex-1 space-y-1 bg-white sm:space-y-3"
      aria-label="Sidebar"
    >
      <Link
        title="New"
        class="{$location.pathname === '/admin/new'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/new"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>New</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/pre-approved'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/pre-approved"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Pre-approved</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/verification'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/verification"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Verification</span>
      </Link>

      <Link
        title="Parking lot"
        class="{$location.pathname === '/admin/parking-lot'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/parking-lot"
      >
        <span>Parking lot</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/approved'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/approved"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Approved</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/pre-payment'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/pre-payment"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Pre-payment</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/paid'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/paid"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Paid</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/rejected'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/rejected"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Rejected</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/incomplete'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/incomplete"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Incomplete</span>
      </Link>

      <Link
        title="New"
        class="{$location.pathname === '/admin/personalinformation'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/personalinformation"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Personal information</span>
      </Link>

      <Link
        title="Dealer Report"
        class="{$location.pathname === '/admin/report'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/report"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Dealer Report</span>
      </Link>

      <Link
        title="Receipts without dealerId"
        class="{$location.pathname === '/admin/recipts-without-dealerId'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/recipts-without-dealerId"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Receipts without dealerId</span>
      </Link>
      <Link
        title="Compare"
        class="{$location.pathname === '/admin/compare'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/compare"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Matching Report</span>
      </Link>

      <Link
        title="Compare Simple"
        class="{$location.pathname === '/admin/compare-simple'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/compare-simple"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Matching Report Simple</span>
      </Link>

      <Link
        title="Dealership Report"
        class="{$location.pathname === '/admin/dealership-report'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/dealership-report"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Dealership Report</span>
      </Link>
      <Link
        title="Receipts Backup"
        class="{$location.pathname === '/admin/purchase-recipts-backup'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/purchase-recipts-backup"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Receipts Backup</span>
      </Link>
      <Link
        title="Parts"
        class="{$location.pathname === '/admin/parts'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/parts"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Parts</span>
      </Link>
      <Link
        title="Dealerships"
        class="{$location.pathname === '/admin/dealerships'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/dealerships"
      >
        <!-- <Repeat class=" text-primary-500 lg:mr-3 flex-shrink-0 h-6 w-6" /> -->
        <span>Dealerships</span>
      </Link>
      <Link
        title="VIN Allowlist"
        class="{$location.pathname === '/admin/vin-allowlist'
          ? 'border-primary-600 bg-primary-50 text-primary-600'
          : 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'}  group flex w-full items-center justify-center border-t-4 px-3 py-2 text-sm font-medium sm:flex-none sm:border-l-4 sm:border-t-0 lg:!justify-start"
        to="/admin/vin-allowlist"
      >
        <span>VIN Allowlist</span>
      </Link>
    </nav>

    <!-- Logout section at bottom of sidebar -->
    <div class="px-3 pb-4">
      <button
        on:click={logout}
        class="flex w-full items-center justify-center rounded-md border border-transparent px-3 py-2 text-sm font-medium text-red-600 transition-colors duration-200 hover:border-red-200 hover:bg-red-50 hover:text-red-700"
        title="Logout"
      >
        <span>Logout</span>
      </button>
    </div>
  </div>
</div>

<!-- <style lang="postcss">
  @media (max-width: 640px) {
    .nav-container {
      position: fixed;
      bottom: 0;
      flex-direction: row;
      z-index: 999;

      box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.85);

      max-width: 100%;
      width: 100%;
      margin: 0 auto;
      min-height: 50px;
      height: 50px;
    }
    .nav-items {
      flex-direction: row;
      display: flex;
      flex: 1 1 0%;
      margin-top: 0;
    }
  }

  @media (min-width: 1024px) {
    .hide-nav-item {
      display: block;
    }
  }
</style> -->
